import React from 'react';
import styled from 'styled-components/macro';
import { RouteComponentProps } from 'react-router-dom';

import { TabBar, TabItem } from '@deeptrue-frontend/ui';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { useFormatMessage } from 'components/IntlProvider';

const StyledTabItem = styled(TabItem)``;

const TabBarWrapper = styled.div`
  margin: 0rem 0 2rem;
  width: 100%;
`;

const { withRouter } = RouterProvider;

export type Tab = 'groups' | 'projects' | 'products';
interface Props extends RouteComponentProps {
  tab: Tab;
  selectTab: (tab: Tab) => void;
}

const Menu = ({ tab, selectTab, history }: Props) => {
  const tabs = ['groups', 'projects', 'products'];
  const t = useFormatMessage();
  const selected = tabs.findIndex((tabOption) => tabOption === tab);
  return (
    <TabBarWrapper>
      <TabBar
        selectedIndex={selected}
        onSelect={(value: number) => {
          history.replace({
            search: `tab=${tabs[value]}`,
          });
          return selectTab(tabs[value] as Tab);
        }}
      >
        <StyledTabItem title={t('organization.groups', 'Groups')} />
        <StyledTabItem title={t('organization.projects', 'Projects')} />
        <StyledTabItem title={t('organization.products', 'Products')} />
      </TabBar>
    </TabBarWrapper>
  );
};

export default withRouter(Menu);
